import { getAxiosInstanceApi, getAxiosMultiPartInstanceApi } from "./api";
import { cachiosInstance } from "./cacheApi";

/**
 * ----------------------------
 *  Investment Opportunity routes
 * ----------------------------
 */

export const getInvestmentOpportunity = (query, force = false, callback) => {
    cachiosInstance.get(`/investment-opportunity?${query}`, { force })
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const newInvestmentOpportunity = (data, callback) => {
    getAxiosMultiPartInstanceApi().post(`/investment-opportunity`, data)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const updateInvestmentOpportunity = (investmentOpportunityId, data, callback) => {
    getAxiosMultiPartInstanceApi().post(`/investment-opportunity/${investmentOpportunityId}?_method=PUT`, data)
        .then(response => {
            const data = response.data;
            callback(true, data.data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getInvestmentOpportunityDashboard = (callback) => {
    cachiosInstance.get(`/investment-opportunity/dashboard`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getInvestmentOpportunityTransactions = (query, callback) => {
    cachiosInstance.get(`/investment-opportunity-transactions?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};
export const getInvestmentTransactionsExport = (query, callback) => {
    getAxiosInstanceApi().get(`/investment-opportunity-transactions/export?${query}`)
        .then(response => {
            const data = response.data;
            callback(true, data);
        }).catch(error => {
            callback(false, error?.response?.data);
        });
};